import { formatValue, getAddedOrDeletedMessage, getValClassName, isItemAdded, renderEdition } from './common';

import type { ChangelogDiff, ChangelogRule, FormatterContext } from './types';

export const SCHEDULE_ORDER = 1000;

function getScheduleLabel(
  change: ChangelogDiff,
  { entity, formatMessage }: FormatterContext,
  segments: number
): string {
  const pathSegments = (change.path ?? []).slice(2, 2 + segments);
  return [
    entity,
    formatMessage({ defaultMessage: 'Schedule Parting', id: 'changelogModal.message.schedule' }),
    ...pathSegments
  ].join(' ');
}

export const scheduleRules: ChangelogRule[] = [
  {
    format: (change, context) =>
      renderEdition(getScheduleLabel(change, context, 2), formatValue(change.lhs), formatValue(change.rhs), context),
    order: SCHEDULE_ORDER,
    regex: /^E\.scheduleParting\.config(\.|$)/,
    section: 'schedule'
  },
  {
    format: (change, context) => (
      <div className={getValClassName('edit')}>
        <b>{`${getScheduleLabel(change, context, 1)} `}</b>
        {getAddedOrDeletedMessage(isItemAdded(change), context.formatMessage)}
      </div>
    ),
    order: SCHEDULE_ORDER,
    regex: /^A\.scheduleParting(\.|$)/,
    section: 'schedule'
  },
  {
    format: (_change, { entity, formatMessage }) => (
      <div className={getValClassName('edit')}>
        <b>
          {`${entity} ${formatMessage({
            defaultMessage: 'Schedule Parting',
            id: 'changelogModal.message.schedule'
          })} ${formatMessage({ defaultMessage: 'config changed', id: 'changelogModal.message.config' })}`}
        </b>
      </div>
    ),
    order: SCHEDULE_ORDER,
    regex: /^N\.scheduleParting(\.|$)/,
    section: 'schedule'
  },
  {
    format: (change, { formatMessage }) => (
      <div className={getValClassName('edit')}>
        {`${formatMessage({ defaultMessage: 'End date changed from', id: 'changelogModal.message.endDate' })} `}
        <b>{formatValue(change.lhs)}</b>
        {` ${formatMessage({ defaultMessage: 'to', id: 'changelogModal.message.to' })} `}
        <b>{formatValue(change.rhs)}</b>
      </div>
    ),
    order: SCHEDULE_ORDER + 10,
    regex: /^E\.endDate$/,
    section: 'schedule'
  }
];
